var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{attrs:{"message":"Wystąpił problem w czasie łączenia z serwerem aplikacji.","button-label":"Spróbuj ponownie"},on:{"action-clicked":_vm.handleReload}})
}
var staticRenderFns = []

export { render, staticRenderFns }